import React from 'react';
import Image from 'next/image';

const WhyChoose = () => {
    return (
        <div className="section-py">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="text-center lg:col-span-10 lg:col-start-2 pb-50">
                        <h2 data-aos="fade-up" data-aos-duration="700" data-aos-delay="100" className="mb-2.5">
                            Why Choose Moweb for Your White Label Taxi Booking App Development?
                        </h2>
                        <p data-aos="fade-up" data-aos-duration="700" data-aos-delay="100" className="mb-0 fw-600">
                            Moweb is an expert white label taxi app development services provider offering cross-platform app (iOS
                            & Android) for cab aggregation or a delivery business. If you are looking for an app just like Ola,
                            Lyft, or Uber, then Moweb provides customized and comprehensive approach to know about their
                            carpooling app needs.
                        </p>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 mx-auto">
                    <div
                        className="card p-30 bg-white dark:bg-black rounded-10 border"
                        data-aos="fade-up"
                        data-aos-duration="700"
                        data-aos-delay="300"
                    >
                        <div className="card-body">
                            <Image
                                src={'/img/icons/ic-extension-development.svg'}
                                height={64}
                                width={64}
                                alt="development"
                                title="development"
                                className="img-fluid mb-5"
                            />
                            <h3 className="card-title fs-lg fw-700 mb-0 text-textcolor">
                                Least development time and yet, a fully customized solution
                            </h3>
                        </div>
                    </div>
                    <div
                        className="card p-30 bg-white dark:bg-black rounded-10 border"
                        data-aos="fade-up"
                        data-aos-duration="700"
                        data-aos-delay="300"
                    >
                        <div className="card-body">
                            <Image
                                src={'/img/icons/ic-finicial-plan.svg'}
                                height={64}
                                width={64}
                                alt="finicial-plan"
                                title="finicial-plan"
                                className="img-fluid mb-5"
                            />
                            <h3 className="card-title fs-lg fw-700 mb-0 text-textcolor">
                                The best technical support that is within your financial plan
                            </h3>
                        </div>
                    </div>
                    <div
                        className="card p-30 bg-white dark:bg-black rounded-10 border"
                        data-aos="fade-up"
                        data-aos-duration="700"
                        data-aos-delay="300"
                    >
                        <div className="card-body">
                            <Image
                                src={'/img/icons/ic-knowledge.svg'}
                                height={64}
                                width={64}
                                alt="knowledge"
                                title="knowledge"
                                className="img-fluid mb-5"
                            />
                            <h3 className="card-title fs-lg fw-700 mb-0 text-textcolor">
                                Domain knowledge as well as expertise of more than a decade
                            </h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WhyChoose;
